var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlfaBankPartnerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 89,
    viewBox: "0 0 242 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_1748)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.892 32.1353L207.82 40.1427V32.1353H202.703V52.3515H207.82V43.8414L215.39 52.3515H222L212.689 41.7585L221.325 32.1353H214.892Z",
    fill: "#115EF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.783 39.6759H187.649V32.1353H182.487V52.3515H187.649V44.3798H194.783V52.3515H199.946V32.1353H194.783V39.6759Z",
    fill: "#115EF3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_129_1748",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 23,
    width: 204,
    height: 44
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.865H222V66.1353H18V23.865Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_129_1748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2319 43.0871C48.1112 46.8566 47.6361 47.6117 45.5676 47.6117V52.3515H46.3388C51.4989 52.3515 52.7398 49.6222 52.93 43.5542L53.1402 36.8392H57.9784V52.3515H63.0271V32.1353H48.5826L48.2319 43.0871Z",
    fill: "#115EF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1694 47.8992H71.8469V42.7642H75.1694C76.9557 42.7642 78.0274 43.5543 78.0274 45.2417C78.0274 47.0731 76.9914 47.8992 75.1694 47.8992ZM75.5623 38.2756H71.8469V32.1353H66.7026V52.3515H75.634C81.2427 52.3515 83.2432 48.689 83.2432 45.2417C83.2432 40.7894 80.4569 38.2756 75.5623 38.2756Z",
    fill: "#115EF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1342 47.3547V36.0714C101.986 36.4616 103.768 38.5905 103.768 41.7129C103.768 44.8353 101.986 46.9642 99.1342 47.3547ZM94.0011 47.3547C91.1493 46.9642 89.3668 44.8353 89.3668 41.7129C89.3668 38.5905 91.1493 36.4616 94.0011 36.0714V47.3547ZM99.1342 31.281V23.865H94.0011V31.281C88.1193 31.7777 84.1621 35.9294 84.1621 41.7129C84.1621 47.5319 88.1193 51.6836 94.0011 52.18V59.7028H99.1342V52.18C105.016 51.7188 108.973 47.5319 108.973 41.7129C108.973 35.8939 105.016 31.7422 99.1342 31.281Z",
    fill: "#115EF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.912 44.4741C122.912 46.76 121.308 48.0613 119.215 48.0613C117.402 48.0613 115.973 47.393 115.973 45.4236C115.973 43.4895 117.542 43.1732 118.902 43.1732H122.912V44.4741ZM127.934 45.7754V39.1292C127.934 34.2763 124.865 31.2164 119.704 31.2164C114.368 31.2164 111.544 34.4519 111.299 37.8279H116.391C116.565 37.0893 117.332 35.8236 119.704 35.8236C121.657 35.8236 122.912 36.7378 122.912 39.1292H117.925C113.461 39.1292 110.811 41.4851 110.811 45.4236C110.811 49.5382 113.71 52.3515 117.89 52.3515C120.956 52.3515 122.657 50.8906 123.4 49.7842C124.063 51.1203 125.528 51.8589 127.445 51.8589H129.189V47.2875C128.283 47.2875 127.934 46.8655 127.934 45.7754Z",
    fill: "#115EF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.937 47.365H143.606V40.2008H148.937C151.706 40.2008 153.264 41.5003 153.264 43.7828C153.264 46.1358 151.706 47.365 148.937 47.365ZM149.179 35.3894H143.606V29.8059H156.518V24.7839H138.378V52.3515H149.179C155.167 52.3515 158.595 49.3315 158.595 43.7828C158.595 38.5506 155.167 35.3894 149.179 35.3894Z",
    fill: "#115EF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.453 44.4741C173.453 46.76 171.848 48.0613 169.756 48.0613C167.942 48.0613 166.513 47.393 166.513 45.4236C166.513 43.4895 168.082 43.1732 169.442 43.1732H173.453V44.4741ZM178.474 45.7754V39.1292C178.474 34.2763 175.405 31.2164 170.244 31.2164C164.909 31.2164 162.084 34.4519 161.84 37.8279H166.931C167.105 37.0893 167.873 35.8236 170.244 35.8236C172.197 35.8236 173.453 36.7378 173.453 39.1292H168.466C164.002 39.1292 161.351 41.4851 161.351 45.4236C161.351 49.5382 164.251 52.3515 168.431 52.3515C171.496 52.3515 173.197 50.8906 173.94 49.7842C174.603 51.1203 176.068 51.8589 177.986 51.8589H179.73V47.2875C178.823 47.2875 178.474 46.8655 178.474 45.7754Z",
    fill: "#115EF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6486 66.1353H18V60.6217H44.6486V66.1353Z",
    fill: "#115EF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9733 41.702L31.7488 30.1918H31.8885L35.4544 41.702H27.9733ZM36.7117 28.0671C35.9441 25.7194 35.0596 23.865 32.0284 23.865C28.9974 23.865 28.0558 25.7119 27.248 28.0671L18.9189 52.3515H24.4425L26.3652 46.5786H36.9926L38.7753 52.3515H44.6487L36.7117 28.0671Z",
    fill: "#115EF3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_1748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 42.2703,
    fill: "white",
    transform: "translate(18 23.8649)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlfaBankPartnerLogo);
export default __webpack_public_path__ + "static/media/alfa-bank-partner-logo.ddb62a205e764ce2d708c1438e6e45a9.svg";
export { ForwardRef as ReactComponent };